// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2sVQj","resendInfoText":"OnGoingPaymentBox_resendInfoText__2VGN7"};